import React from "react";

export default function CardFacility(props) {
  return (
    <>
      <div className="">
        <img
          className="mx-auto lg:mx-0 w-5/6 rounded lg:w-full"
          src={props.source}
          alt=""
        />
        <div className="-mt-2 w-5/6 mx-auto lg:mx-0 2xl:mx-0 2xl:-mt-56 2xl:w-[380px] min-[1920px]:w-[500px]  lg:-mt-32 xl:-mt-48 lg:w-[260px] lg:h-auto xl:w-[320px] rounded-xl  border-2  border-blue-200">
          <div className="p-7 lg:p-6 xl:p-7 2xl:p-0 flex flex-col lg:items-start lg:mt-28 xl:mt-44 2xl:mt-56">
            <div className=" 2xl:px-6 lg:py-4 font-bold text-xl sm:text-2xl">
              {props.title}
            </div>
            <p className="mt-6 mb-2  lg:mt-0 2xl:px-6 2xl:mb-8 text-gray-500 text-sm sm:text-base">
              {props.text}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
